import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";
import { hideLoader, showLoader } from "./loaderSlice";

export const getPetsReportData = createAsyncThunk(
  "getPetsReportData",
  async (url = "?type=pets", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/pets-data${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch pets data");
    }
  },
);

export const getPetsAppointmentsReportData = createAsyncThunk(
  "getPetsAppointmentsReportData",
  async (url = "?type=appointments", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/pets-data${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch pets data");
    }
  },
);

export const getVetsRevenueReportData = createAsyncThunk(
  "getVetsRevenueReportData",
  async (url = "?type=revenue", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/consultations${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet revenue data");
    }
  },
);

export const getVetsSpecialityReportData = createAsyncThunk(
  "getVetsSpecialityReportData",
  async (url = "?type=speciality", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/consultations${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet speciality data");
    }
  },
);

export const getVetsSlotsReportData = createAsyncThunk(
  "getVetsSlotsReportData",
  async (url = "?type=slots", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/consultations${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet slots data");
    }
  },
);

export const getVetsDelaysReportData = createAsyncThunk(
  "getVetsDelaysReportData",
  async (url = "?type=delay", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/consultations${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet delay data");
    }
  },
);

export const getVetsUpcomingsReportData = createAsyncThunk(
  "getVetsUpcomingsReportData",
  async (url = "?type=upcoming", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/consultations${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet upcoming data");
    }
  },
);

export const getAppointmentsTableReportData = createAsyncThunk(
  "getAppointmentsTableReportData",
  async (url = "?status=completed", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/appointments/comprehensive${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch appointment data");
    }
  },
);

export const getAppointmentsFacilityReportData = createAsyncThunk(
  "getAppointmentsFacilityReportData",
  async (url = "?type=facility", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/appointments/comprehensive${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch facility data");
    }
  },
);

export const getBillingRevenueReportData = createAsyncThunk(
  "getBillingRevenueReportData",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/billing/revenue-dump${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing revenue data");
    }
  },
);

export const getBillingSalesReturnReportData = createAsyncThunk(
  "getBillingSalesReturnReportData",
  async (url = "?purchaseType=Sales", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/billing/revenue-dump${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing return data");
    }
  },
);

export const getBillingPurchaseReturnReportData = createAsyncThunk(
  "getBillingPurchaseReturnReportData",
  async (url = "?purchaseType=Purchase", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/billing/revenue-dump${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing return data");
    }
  },
);

export const getStockDumpReportData = createAsyncThunk(
  "getStockDumpReportData",
  async (url = "?type=dump", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/inventory/stock${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock dump data");
    }
  },
);

export const getStockBatchReportData = createAsyncThunk(
  "getStockBatchReportData",
  async (url = "?type=batch", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/inventory/stock${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock batch data");
    }
  },
);

export const getStockReturnReportData = createAsyncThunk(
  "getStockReturnReportData",
  async (url = "?type=returns", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/inventory/stock${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock return data");
    }
  },
);

export const getServiceTableReportData = createAsyncThunk(
  "getServiceTableReportData",
  async (url = "?type=summary", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/services/table-data${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch service report data");
    }
  },
);

export const getServiceAppointmentsReportData = createAsyncThunk(
  "getServiceAppointmentsReportData",
  async (url = "?type=detail", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/services/table-data${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch service report data");
    }
  },
);

const reportSlice = createSlice({
  name: "report",
  initialState: {
    pets: {},
    appointments: {},
    vetRevenue: {},
    vetSpeciality: {},
    vetSlots: {},
    vetDelays: {},
    vetUpcomings: {},
    appointmentTable: {},
    appoinmentFacility: {},
    billingRevenue: {},
    billingSalesReturn: {},
    billingPurchaseReturn: {},
    serviceTable: {},
    serviceAppointments: {},
    stockDump: {},
    stockBatch: {},
    stockReturn: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPetsReportData.fulfilled, (state, action) => {
      state.pets = action.payload ?? {};
      state.loading = false;
      state.error = null;
    });
    builder.addCase(
      getPetsAppointmentsReportData.fulfilled,
      (state, action) => {
        state.appointments = action.payload ?? {};
        state.loading = false;
        state.error = null;
      },
    );
    builder.addCase(getVetsRevenueReportData.fulfilled, (state, action) => {
      state.vetRevenue = action.payload ?? {};
    });
    builder.addCase(getVetsSpecialityReportData.fulfilled, (state, action) => {
      state.vetSpeciality = action.payload ?? {};
    });
    builder.addCase(getVetsSlotsReportData.fulfilled, (state, action) => {
      state.vetSlots = action.payload ?? {};
    });
    builder.addCase(getVetsDelaysReportData.fulfilled, (state, action) => {
      state.vetDelays = action.payload ?? {};
    });
    builder.addCase(getVetsUpcomingsReportData.fulfilled, (state, action) => {
      state.vetUpcomings = action.payload ?? {};
    });
    builder.addCase(
      getAppointmentsTableReportData.fulfilled,
      (state, action) => {
        state.appointmentTable = action.payload ?? {};
      },
    );
    builder.addCase(
      getAppointmentsFacilityReportData.fulfilled,
      (state, action) => {
        state.appoinmentFacility = action.payload ?? {};
      },
    );
    builder.addCase(getBillingRevenueReportData.fulfilled, (state, action) => {
      state.billingRevenue = action.payload ?? {};
    });
    builder.addCase(
      getBillingSalesReturnReportData.fulfilled,
      (state, action) => {
        state.billingSalesReturn = action.payload ?? {};
      },
    );
    builder.addCase(
      getBillingPurchaseReturnReportData.fulfilled,
      (state, action) => {
        state.billingPurchaseReturn = action.payload ?? {};
      },
    );
    builder.addCase(getStockDumpReportData.fulfilled, (state, action) => {
      state.stockDump = action.payload ?? {};
    });
    builder.addCase(getStockBatchReportData.fulfilled, (state, action) => {
      state.stockBatch = action.payload ?? {};
    });
    builder.addCase(getStockReturnReportData.fulfilled, (state, action) => {
      state.stockReturn = action.payload ?? {};
    });
    builder.addCase(getServiceTableReportData.fulfilled, (state, action) => {
      state.serviceTable = action.payload ?? {};
    });
    builder.addCase(
      getServiceAppointmentsReportData.fulfilled,
      (state, action) => {
        state.serviceAppointments = action.payload ?? {};
      },
    );
  },
});

export default reportSlice.reducer;
